export default [{
        path: '/news',
        name: 'news',
        component: () =>
            import ('@/views/modules/news/news-list/NewsList.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Noticias',
            breadcrumb: [{
                text: 'Lista de noticias',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/news/create',
        name: 'news-create',
        component: () =>
            import ('@/views/modules/news/news-store/NewsStore.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Noticias',
            breadcrumb: [{
                text: 'Lista de noticias',
                to: { name: 'news' }
            }, {
                text: 'Nueva noticia',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/news/:id/edit',
        name: 'news-edit',
        component: () =>
            import ('@/views/modules/news/news-edit/NewsEdit.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Noticias',
            breadcrumb: [{
                text: 'Lista de noticias',
                to: { name: 'news' }
            }, {
                text: 'Editar noticia',
                active: true
            }],
            requiresAuth: true
        }
    }
]
